module.exports = "/images/shopping-cart-2.svg";